<div class="flex">
  <div [ngClass]="getStatusIcon" class="status_indicator cp-mr-12">

  </div>

  <div class="data" [innerHTML]="data.message"></div>

  <div class="close_indicator" (click)="snackBarRef.dismiss()">

  </div>
</div>

